import classNames from "classnames";
import type { MessageAttributes } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { getHtmlString } from "@/shared/utils/htmlMarkupGeneration";

const alertTypes = {
    info: "alertInfo",
    warn: "alertWarn",
    err: "alertError",
} as const;

export const Message = ({ type, text, tags }: MessageAttributes) => (
    <Grid.Container>
        <Grid.Field spanDesktop={12} spanTablet={12} spanMobile={12}>
            <div
                className={classNames("alert", alertTypes[type])}
                dangerouslySetInnerHTML={{
                    __html: getHtmlString({
                        message: text,
                        formatTags: tags,
                    }),
                }}
            />
        </Grid.Field>
    </Grid.Container>
);
